<template>
  <span :class="`font-icon icon-${category}`">{{ name }}</span>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },

  computed: {
    category() {
      return this.name.split("_")[0];
    },
  },
};
</script>

<style lang="scss">
@include fontFace("UI", "../../assets/fonts", "ui", normal, 400);

@include fontFace(
  "Categories",
  "../../assets/fonts",
  "categories",
  normal,
  400
);

.font-icon {
  &.icon-category {
    font-family: "Categories";
  }

  &.icon-ui {
    font-family: "UI";
  }

  font-weight: 400;
  font-style: normal;
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;
  // font-feature-settings: "liga";
  font-feature-settings: "liga" 1;
  -ms-font-feature-settings: "liga" 1;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;
}
</style>
